/**
 * Port type identity for canvas connections.
 * Agents/packages declare ports via canvas-artifacts $ref; when only `$ref` is
 * present (no JSON Schema `type`), connections must still match.
 */
export function portTypeKey(schema) {
  if (!schema || typeof schema !== 'object') {
    return null;
  }
  if (typeof schema.$ref === 'string' && schema.$ref.length > 0) {
    return schema.$ref;
  }
  if (typeof schema.type === 'string' && schema.type.length > 0) {
    return schema.type;
  }
  return null;
}

export function portsCompatible(sourceSchema, targetSchema) {
  const sourceType = portTypeKey(sourceSchema);
  const targetType = portTypeKey(targetSchema);
  return Boolean(sourceType && targetType && sourceType === targetType);
}
